import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Box, Button, Text, Anchor, ResponsiveContext } from 'grommet';
import { MailOption, CirclePlay, Clock, WhatsApp } from 'grommet-icons';

import { HeaderHtml } from '../../../components';
import urlRoutes from '../../../config/url-routes';

class OnBoardingWelcome extends Component {
  nextStep = () => {
    const { history } = this.props;
    history.push(urlRoutes.login);
  };

  render() {
    return (
      <ResponsiveContext.Consumer>
        {size => (
          <>
            <HeaderHtml title='Olá, agora você faz parte do Gerencia Meu Mandato!' />

            <Box
              height='100vh'
              align='center'
              justify='center'
            >
              <Box
                direction={ size === 'small' || size === 'medium' ? 'column' : 'row' }
                margin={{ horizontal: 'medium' }}
                width='xlarge'
                pad='small'
                gap='medium'
                flex={{ shrink: 0 }}
              >
                {/* primeira coluna */}
                <Box
                  gap='large'
                  flex={{ shrink: 0 }}
                >
                  {/* Info */}
                  <Box
                    gap='small'
                    width={ size === 'small' || size === 'medium' ? 'xlarge' : 'medium' }
                  >
                    <Text color='brand' size='medium'>
                      SEJA BEM-VINDO(A)
                    </Text>

                    <Text color='dark-1' size='xxlarge' weight='bold'>
                      Tudo o que você e sua equipe precisam para uma gestão
                      <Text color='brand' size='xxlarge'> mais eficiente!</Text>
                    </Text>

                    <Text color='dark-5' size='small'>
                      Organize o relacionamento com a população, acompanhe demandas,
                      monitore emendas, facilite a agenda e muito mais.
                    </Text>
                  </Box>

                  {/* Vídeo */}
                  <Box
                    direction='row'
                    round='small'
                    background={{ color: 'brand', opacity: 'weak' }}
                    pad='medium'
                    gap='small'
                    justify='between'
                  >
                    {/* informativo */}
                    <Box
                      gap='xsmall'
                    >
                      <Text color='brand' size='xsmall'>
                        VÍDEO DE APRESENTAÇÃO
                      </Text>

                      <Text color='dark-1' size='large'>Conheça o Gerencia Meu Mandato</Text>

                      <Box
                        gap='xsmall'
                        direction='row'
                        align='center'
                      >
                        <Clock color='brand' />
                        <Text color='dark-3' size='small'>1 min</Text>
                      </Box>
                    </Box>


                    {/* componente tela */}
                    <Box
                      round='xsmall'
                      border={{ color: 'light-5', size: 'xsmall' }}
                      width='small'
                    >
                      <Box
                        direction='row'
                        round={{ corner: 'top', size: 'xsmall' }}
                        pad={{ horizontal: 'small', vertical: 'xsmall' }}
                        background={{ color: 'light-1' }}
                        gap='small'
                      >
                        <Box width='1vw' height='1vw' background='status-critical' round='large' />
                        <Box width='1vw' height='1vw' background='accent-4' round='large' />
                        <Box width='1vw' height='1vw' background='accent-1' round='large' />
                      </Box>

                      <Box
                        round={{ corner: 'bottom', size: 'xsmall' }}
                        background='light-1'
                        pad='small'
                        align='center'
                      >
                        <Anchor
                          href='https://youtu.be/Kvnfk5lElR4'
                          target='_blank'
                          icon={<CirclePlay color='brand' size='large' />}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>


                {/* Separador coluna */}
                <Box
                  width={ size === 'large' || size === 'xlarge' ? 'xsmall' : 'xxsmall' }
                />


                {/* segunda coluna */}
                <Box
                  gap='large'
                >
                  {/* Info */}
                  <Box
                    gap='small'
                  >
                    <Text
                      color='dark-1'
                      size='xlarge'
                      weight='bold'
                    >
                      Pronto para continuar?
                    </Text>

                    <Text color='dark-5' size='small'>
                      Clique no botão abaixo para acessar o sistema e gerenciar seu mandato e campanha eleitoral.
                    </Text>

                    <Button
                      primary
                      label='Acessar o sistema'
                      onClick={this.nextStep}
                    />
                  </Box>

                  <Box
                    gap='small'
                  >
                    <Text size='small' color='dark-5' >
                      Precisa de ajuda? Estamos disponíveis para atender por WhatsApp ou e-mail.
                    </Text>

                    <Anchor
                      size='small'
                      href='https://api.whatsapp.com/send?phone=5519988508644'
                      label='(19) 98850-8644'
                      icon={<WhatsApp color='dark-5' />}
                      target='_blank'
                    />

                    <Anchor
                      size='small'
                      href='mailto:contato@gerenciameumandato.com.br'
                      label='contato@gerenciameumandato.com.br'
                      icon={<MailOption color='dark-5' />}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        )}
      </ResponsiveContext.Consumer>
    )
  }
}

export default withRouter(OnBoardingWelcome);
